(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digi-wp-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-digi-wp-bundle-add]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var id=btn.getAttribute('data-variant-id');
      if(!id){window.location='/cart';return;}
      var drawer=document.querySelector('cart-drawer');
      var orig=btn.textContent;
      btn.disabled=true;btn.textContent='Ajout en cours';
      // Pattern natif de Dawn : les sections a redessiner sont demandees dans la
      // requete d'ajout. La reponse contient donc deja le HTML a jour, ce qui
      // evite un second aller-retour et un tiroir affichant un contenu perime.
      var charge={items:[{id:parseInt(id,10),quantity:1}]};
      if(drawer&&typeof drawer.getSectionsToRender==='function'){
        charge.sections=drawer.getSectionsToRender().map(function(s){return s.id;});
        charge.sections_url=window.location.pathname;
      }
      fetch('/cart/add.js',{method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/javascript'},
        body:JSON.stringify(charge)})
        .then(function(r){return r.json();})
        .then(function(res){
          if(res.status){throw new Error(res.description||res.message||'ajout refuse');}
          if(drawer&&res.sections&&typeof drawer.renderContents==='function'){
            drawer.renderContents(res);
            if(typeof drawer.open==='function'){drawer.open(btn);}
          } else {
            window.location='/cart';return;
          }
          if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
            publish(PUB_SUB_EVENTS.cartUpdate,{source:'digi-wp-bundle'});
          }
          btn.textContent='Ajoute au panier';
          setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1800);
        })
        .catch(function(){btn.textContent=orig;btn.disabled=false;window.location='/cart';});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digi-wp-mobile-dock"] && !Shopify.designMode) return;
  try {
    
(function(){
  var dock=document.querySelector('[data-digi-wp-dock]');
  if(!dock)return;
  // Bouton panier : ouvre le cart-drawer natif Dawn si présent, sinon /cart.
  var cartBtn=dock.querySelector('[data-digi-wp-dock-cart]');
  if(cartBtn){
    cartBtn.addEventListener('click',function(e){
      var drawer=document.querySelector('cart-drawer');
      var bubble=document.getElementById('cart-icon-bubble');
      if(drawer&&bubble){e.preventDefault();bubble.click();}
    });
  }
  // Synchronise le compteur sur la pastille native de Dawn.
  // Dawn ne diffuse pas d'evenement DOM sur le panier : il passe par son propre
  // canal pub/sub. On combine donc trois voies, du plus precis au plus robuste.
  var badge=dock.querySelector('[data-digi-wp-dock-count]');
  function syncCount(){
    if(!badge)return;
    var icon=document.getElementById('cart-icon-bubble');
    var n=0;
    if(icon){
      var el=icon.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if(el){n=parseInt(el.textContent.trim(),10)||0;}
      else if(icon.querySelector('.cart-count-bubble')){n=100;}
    }
    badge.textContent=n>99?'99+':String(n);
    if(n>0){badge.removeAttribute('hidden');}else{badge.setAttribute('hidden','');}
  }
  syncCount();
  // 1. canal pub/sub de Dawn, defini globalement par pubsub.js et constants.js
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.cartUpdate,syncCount);
  }
  // 2. filet de securite : Dawn remplace le contenu de la pastille sans
  //    remplacer l'element, une observation du DOM suffit donc.
  var icon=document.getElementById('cart-icon-bubble');
  if(icon&&'MutationObserver' in window){
    new MutationObserver(syncCount).observe(icon,{childList:true,subtree:true,characterData:true});
  }
  // 3. retour sur la page depuis le cache navigateur
  window.addEventListener('pageshow',syncCount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digi-wp-product-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-digi-wp-finder]').forEach(function(root){
    var sels=root.querySelectorAll('select[data-finder]');
    var titleEl=root.querySelector('[data-finder-title]');
    var descEl=root.querySelector('[data-finder-desc]');
    var ctaEl=root.querySelector('[data-finder-cta]');
    // Table explicite par animal et par besoin. La version precedente derivait
    // le lien chat par substitution de chaine sur le lien chien, ce qui
    // produisait trois collections inexistantes : /collections/laisses,
    // /collections/coussins, /collections/jouets-chien, plus /colliers-chat et
    // /jouets-chat cote chat. Chaque valeur ci-dessous est un handle de
    // collection verifie sur la boutique le 29/07/2026.
    var RECO={
      chien:{
        promenade:{t:'Laisse et collier assortis',d:'Pour des sorties sereines, associez un collier au bon gabarit a une laisse resistante.',c:'/collections/laisses-pour-chien'},
        repos:{t:'Lit ou coussin moelleux',d:'Un couchage doux et de la bonne taille pour un coin calme a la maison.',c:'/collections/coussins-et-couchages-pour-chien'},
        soin:{t:'Brosse et accessoires de toilettage',d:'Une routine simple : brosse adaptee au pelage et lavage facile.',c:'/collections/toilettage-chien'},
        jeu:{t:'Jouets stimulants',d:'De quoi occuper et stimuler votre compagnon au quotidien.',c:'/collections/jouets-pour-chien'}
      },
      chat:{
        promenade:{t:'Harnais et laisse pour chat',d:'Pour habituer un chat aux sorties, un harnais ajustable et une laisse assortie.',c:'/collections/harnais-pour-chat'},
        repos:{t:'Arbre a chat ou couchage',d:'Un espace en hauteur pour griffer, observer et se reposer.',c:'/collections/arbres-a-chat'},
        soin:{t:'Brosse et accessoires de toilettage',d:'Une routine simple : brosse adaptee au pelage et lavage facile.',c:'/collections/toilettage-chat'},
        jeu:{t:'Jouets d eveil',d:'De quoi stimuler l instinct de chasse au quotidien.',c:'/collections/jouets-pour-chat'}
      }
    };
    function val(k){var s=root.querySelector('select[data-finder="'+k+'"]');return s?s.value:'';}
    function update(){
      var animal=val('animal'),need=val('need'),size=val('size');
      var parAnimal=RECO[animal]||RECO.chien;
      var base=parAnimal[need]||parAnimal.promenade;
      if(titleEl)titleEl.textContent=base.t;
      if(descEl)descEl.textContent=base.d+' Gabarit '+size+'.';
      if(ctaEl)ctaEl.setAttribute('href',base.c);
    }
    sels.forEach(function(s){s.addEventListener('change',update);});
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digi-wp-welcome-modal"] && !Shopify.designMode) return;
  try {
    
(function(){
  var boite=document.querySelector('[data-digi-wp-welcome]');
  if(!boite)return;
  var cle=boite.getAttribute('data-cle');
  var memoire=boite.getAttribute('data-memoire');
  var delai=parseInt(boite.getAttribute('data-delai'),10);
  if(isNaN(delai))delai=5;
  var carte=boite.querySelector('.digi-wp-welcome__carte');
  var rendu=null;

  function dejaVue(){
    if(memoire!=='session')return false;
    try{return sessionStorage.getItem(cle)==='1';}catch(e){return false;}
  }
  function memoriser(){
    if(memoire!=='session')return;
    try{sessionStorage.setItem(cle,'1');}catch(e){}
  }
  function fermer(){
    boite.hidden=true;
    document.removeEventListener('keydown',auClavier);
    memoriser();
    if(rendu&&rendu.focus)rendu.focus();
  }
  function auClavier(e){
    if(e.key==='Escape'){fermer();return;}
    if(e.key!=='Tab')return;
    var cibles=carte.querySelectorAll('a[href],button:not([tabindex="-1"]),input,select,textarea');
    if(!cibles.length)return;
    var premier=cibles[0],dernier=cibles[cibles.length-1];
    if(e.shiftKey&&document.activeElement===premier){e.preventDefault();dernier.focus();}
    else if(!e.shiftKey&&document.activeElement===dernier){e.preventDefault();premier.focus();}
  }
  function ouvrir(){
    if(dejaVue())return;
    rendu=document.activeElement;
    boite.hidden=false;
    document.addEventListener('keydown',auClavier);
    var premier=carte.querySelector('button:not([tabindex="-1"]),a[href]');
    if(premier)premier.focus();
  }

  boite.querySelectorAll('[data-welcome-close]').forEach(function(b){
    b.addEventListener('click',fermer);
  });

  // Dans l'editeur de theme, la modale s'affiche immediatement pour rester
  // visible et modifiable, sans memorisation de fermeture.
  if(window.Shopify&&window.Shopify.designMode){
    memoire='always';
    ouvrir();
    return;
  }
  if(dejaVue())return;
  window.setTimeout(ouvrir,delai*1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
